export default class ReceiptService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  async create(receipt, options) {
    const response = await fetch(`${this.baseUrl}/receipt`, {
      body: JSON.stringify(receipt),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUrl}/receipt/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async exportProducts(setAsCompleted, all, options) {
    const response = await fetch(`${this.baseUrl}/receipt/export?setAsCompleted=${setAsCompleted}&all=${all}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUrl}/receipt/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(all, options) {
    const response = await fetch(`${this.baseUrl}/receipt?all=${all}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, receipt, options) {
    const response = await fetch(`${this.baseUrl}/receipt/${id}`, {
      body: JSON.stringify(receipt),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}